import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import {BASE_URL} from '../../config'
import {handleApiError, handleAxiosError} from '../../../utils/helperFunction/_helper'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_API_URL

// export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const GET_USER_BY_ACCESSTOKEN_URL = `${BASE_URL}/api/protect/getuser`
// export const LOGIN_URL = `${API_URL}/login`
const LOGIN_URL = `${BASE_URL}/api/auth/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
const GET_USER_ATTACHMENTS = `${BASE_URL}/api/protect/getUserAllAttachments`
const VALIDATE_USER_IP_URL = `${BASE_URL}/api/auth/isValidateUserIp`

export interface LoginResponse extends AuthModel {
  message?: string
  status?: string
  statuscode?: number
  statusCode?: number
}

// Server should return AuthModel
// export function login(username: string, password: string) {
//   return axios.post<AuthModel>(LOGIN_URL, {
//     username,
//     password,
//   })
// }

export function routeAppLogin(username: string, password: string) {
  return axios
    .post<AuthModel>(LOGIN_URL, {
      username,
      password,
    })
    .then((response) => {
      let res = {
        data: {
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken,
          username: '',
          email: '',
        },
      }

      return res
    })
    .catch((err) => {
      console.log(err)
      const message = handleAxiosError(err)
      // console.log(message)
      toast.error(message)
      let res = {
        data: {
          accessToken: '',
          username: '',
          email: '',
        },
      }

      return res
    })
}

export async function login(username: string, password: string, captchaToken: string) {
  try {
    const response = await axios.post<LoginResponse>(LOGIN_URL, {
      username,
      password,
      ...(captchaToken ? {captchaToken} : {}),
    })

    return response.data
  } catch (err) {
    console.log(err)
    const message = handleAxiosError(err)
    const responseData = (err as any)?.response?.data

    return {
      accessToken: '',
      refreshToken: '',
      username: '',
      email: '',
      message: responseData?.message || message,
      status: responseData?.status || 'error',
      statuscode: responseData?.statuscode ?? responseData?.statusCode ?? 500,
      statusCode: responseData?.statusCode ?? responseData?.statuscode ?? 500,
    }
  }
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken_(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function getUserByToken(token: string | undefined) {
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: {Authorization: `Bearer ${token}`},
  })
}

export function getUserByTokenold(token: string) {
  return axios
    .get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
      headers: {Authorization: `Bearer ${token}`},
    })
    .then((response) => {
      // let result = response;

      console.log('response', response)

      // const { data } = response
      // let res = {
      //   data : {
      //     'api_token' : "adsf",
      //     'username' : "admin",
      //     'email' : "admin@gmail.com",
      //   }
      // }

      // return res
    })
}

export async function getUserAllAttachments() {
  const response = await axios.get(GET_USER_ATTACHMENTS)
  return response.data
}

export async function checkValidateUserIp(): Promise<string> {
  const {data} = await axios.get(VALIDATE_USER_IP_URL)
  return data
}
